
import Icons from "../assets/icons.svg";

export const Icon = ({size=2, name='delete', type='stroke', mold=false, customClass=''}) => {
    const path = `${Icons}#${name}`;

    if ( name === 'edit' || name === 'restart' || name === 'habits' || name === 'delete' ) {
        type = 'fill';
    }

    const typeClass = `icon--${type}`;
    const nameClass = `icon--${name}`;
    const modifierClass = mold && mold === true ? 'icon--molding' : '';

    return (
        <svg className={`icon icon--${size} ${typeClass} ${modifierClass} ${nameClass} ${customClass}`} role="presentation">
            <use xlinkHref={path}></use>
        </svg>
    )
}

export default Icon;